import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';

class CokiesPolicy extends Component {
    render() {
        return (
            <div className="cokies-policy">
                <Row className="justify-content-center">
                    <Col md="6">
                        <div>
                        <h1 style={{color:'Black',textAlign:'center'}}> Privacy Policy</h1>
                            <p className="">
                            
                            <p >This Privacy Policy explains our commitments and your rights concerning your information. You should read the Privacy Policy carefully. If you do not agree with this Privacy Policy, please do not use our Sites or Services. The Privacy Policy is duly incorporated and subject to the Terms of Service and governs the same Services and Sites as the ones mentioned in the Terms of Service. Any terms we use in the Privacy Policy without defining them have the same definition as in the Terms of Service.</p>
<h2 style={{color:'Black'}}>WE COLLECT INFORMATION THE FOLLOWING WAYS:</h2>

<p>1. When you give it to us or give us permission to obtain it If you choose to subscribe to a Service from us, we or the mobile operator of your network will collect your information related to the payment for the subscription of our Services. Account and billing information collected by the mobile operator are subject to their respective privacy policies.
    </p>

<p>
    2. We get technical information when you visit our Sites and/or Services We may collect technical information about you whenever you use our Services. We collect log data every time you log in or log out of our Services.

</p>
<h2 style={{color:'Black'}}>HOW WE USE COLLECTED INFORMATION</h2>
<h3 style={{color:'Black'}}>We may use your information for the following purposes:</h3>
<p>
·       Provide the Service(s) you request;
·       Bill and collect for the Service(s) provided to you;
</p>
<h2 style={{color:'Black'}}>HOW LONG WE KEEP YOUR INFORMATION</h2>
<p>We will retain your information for as long as needed to provide our Services to you. We will retain your information as necessary to comply with our legal obligations, resolve disputes and enforce our agreements.
When we no longer need to use your information and there is no need for us to keep it to comply with our legal or regulatory obligations, we will either remove it from our systems or depersonalize it so that we can no longer identify you.
</p>
 
<h2 style={{color:'Black'}}>HOW WE PROTECT YOUR INFORMATION ALSO OUTSIDE THE EU</h2>
<p>We are concerned with protecting your privacy and data, but we cannot ensure or warrant the security of any information you transmit to us or guarantee that your information may not be accessed, disclosed, altered or destroyed by breach of any of our industry standard physical, technical or managerial safeguards. We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized or accidental access, alteration, disclosure or destruction of your information, transaction information and data stored on our Services.
However, no method of transmission over the internet or method of electronic storage is 100% secure. Therefore, we cannot guarantee its absolute security. We will continue to enhance our security procedures as new technology becomes available.
Because we operate internationally, your information, including personal information, may be transferred to and made available in the USA/Singapore and/or any other country than your country of residence. Also in these countries, we take all reasonable care to protect your personal information.
</p>
<h2 style={{color:'Black'}}>ACCEPTANCE OF PRIVACY POLICY</h2>
<p>By using any of our Services, you consent to our collection and use of your information in accordance with this Privacy Policy. We reserve the right to modify this Privacy Policy at any time by posting the changes on this page. Please check the revision date at the bottom of this page to determine if the policy has been modified since you last reviewed it. Your continued use of any portion of our Site or Services following the posting of the updated Privacy Policy will constitute your acceptance of the changes.
</p>
<h2 style={{color:'Black'}}>CHANGES TO THIS PRIVACY POLICY</h2>
<p>We may make changes in our Privacy Policy from time to time. If we decide to change our Privacy Policy, we will post those changes on this page so that you can always access the latest Privacy Policy.
</p>
<h2 style={{color:'Black'}}>CONTACTING US</h2>
<p>If you have a question about this Privacy Policy, the practices of the Sites, or your dealings with the Sites, please contact us by sending an e-mail 
    to <p style={{color:'blue'}}>support@content-clubs.com</p>
    </p>

                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}


export default CokiesPolicy;


// WEBPACK FOOTER //
// ./src/containers/CokiesPolicy.js